let menuDevtest = [    
    {
        path: '/',
        component: "HomeView",
        name: '测试组件',
        parent:true,
        children:[		
            { 
                pageAddress: "devtest/TestNewSelectOrCreateBankWidget",
                path: '/devtest/TestNewSelectOrCreateBankWidget/index', 
                name: '新版银行选择组件',
            },
            {
                pageAddress: "devtest/TestNewSelectOperationWidget",
                path: '/devtest/TestNewSelectOperationWidget/index',
                name: '新版选择子公司和运营中心',
            },
            {
                pageAddress: "devtest/TestUploadIdCard",
                path: '/devtest/TestUploadIdCard/index',
                name: '身份证上传',
            },
            { 
                pageAddress: "devtest/TestCompanySelectWidget",
                path: '/devtest/TestCompanySelectWidget/index', 
                name: '甲方公司选择组件',
            },
            {
                pageAddress: "devtest/TestDistrictIndex",
                path: '/devtest/TestDistrictIndex/index',
                name: '选择地址组件',
            },
            {
                pageAddress: "devtest/TestFileAttachUpload",
                path: '/devtest/TestFileAttachUpload/index',
                name: '上传图片组件',
            },
            {
                pageAddress: "devtest/TestProjectSelectWidget",
                path: '/devtest/TestProjectSelectWidget/index',
                name: '选择项目组件',
            },
            {
                pageAddress: "devtest/TestBackUserSelectWidget",
                path: '/devtest/TestBackUserSelectWidget/index',
                name: '选择用户组件',
            },
            {
                pageAddress: "devtest/TestBankInfoSelectOrCreateWidget",
                path: '/devtest/TestBankInfoSelectOrCreateWidget/index',
                name: '选择银行以及分行组件',
            },
            {
                pageAddress: "devtest/TestBusinessIntroducerSelectOrCreateWidget",
                path: '/devtest/TestBusinessIntroducerSelectOrCreateWidget/index',
                name: '选择业务介绍人',
            },
            {
                pageAddress: "devtest/TestChiefInspSelectWidget",
                path: '/devtest/TestChiefInspSelectWidget/index',
                name: '选择项目总监',
            },
            {
                pageAddress: "devtest/TestContractSelectWidget",
                path: '/devtest/TestContractSelectWidget/index',
                name: '选择合同',
            },
            {
                pageAddress: "devtest/TestCustomerSelectOrCreateWidget",
                path: '/devtest/TestCustomerSelectOrCreateWidget/index',
                name: '选择客户',
            },
            {
                pageAddress: "devtest/TestDModal",
                path: '/devtest/TestDModal/index',
                name: '模态框组件',
            },
            {
                pageAddress: "devtest/TestEngineering",
                path: '/devtest/TestEngineering/index',
                name: '工装类型',
            },
            {
                pageAddress: "devtest/TestOperationCenterSelectOrCreateWidget",
                path: '/devtest/TestOperationCenterSelectOrCreateWidget/index',
                name: '选择运营中心组件',
            },
            {
                pageAddress: "devtest/TestManContractSelectWidget",
                path: '/devtest/TestManContractSelectWidget/index',
                name: '选择主合同组件',
            },
            {
                pageAddress: "devtest/TestDColumnAmount",
                path: '/devtest/TestDColumnAmount/index',
                name: '加减输入框',
            },
            {
                pageAddress: "devtest/TestDColumnDatePicker",
                path: '/devtest/TestDColumnDatePicker/index',
                name: '日期选择组件',
            },
            {
                pageAddress: "devtest/TestDColumnChooseXmCompany",
                path: '/devtest/TestDColumnChooseXmCompany/index',
                name: '新美子公司',
            },
            {
                pageAddress: "devtest/TestFileUploadWidget",
                path: '/devtest/FileUploadWidget/index',
                name: '新版上传组件',
            },



            		
		]
    },    
    {
        path: '/',
        component: "HomeView",
        name: '原型页面',
        parent:true,
        children:[
            {
                pageAddress: "devtest/ProtoMessageBox",
                path: '/devtest/ProtoMessageBox/index',
                name: '消息框',
            },
            {
                pageAddress: "devtest/ProtoSelectBank",
                path: '/devtest/ProtoSelectBank/index',
                name: '选择银行',
            },
            {
                pageAddress: "devtest/ProtoSelectCompanyAndOperations",
                path: '/devtest/ProtoSelectCompanyAndOperations/index',
                name: '选择公司和运营中心',
            },
            {
                pageAddress: "devtest/ProtoUploadIdCard",
                path: '/devtest/ProtoUploadIdCard/index',
                name: '上传身份证',
            },
            		
		]
    }
    
];


export default menuDevtest;


// WEBPACK FOOTER //
// ./src/menu/menuDevtest.js